import React, { useMemo } from "react";
import { Grid } from "@mui/material";

import TabsObjetivosTP from "./TabsObjetivosTP";
import TabsObjetivosOrganizacion from "./TabsObjetivosOrganizacion";
import CurriculumNacionalABPPanel from "./CurriculumNacionalABPPanel";

type SimpleIdNombre = { id: string; nombre: string };

type Props = Readonly<{
  mode: "TP" | "ORG" | "CN";

  // TP
  especialidadId: string;
  nivelTPId: string;
  asignaturaSeleccionadaTP: SimpleIdNombre | null;

  // ORG
  nivelOrg: SimpleIdNombre;
  asignaturaOrg: SimpleIdNombre;

  // CN
  nivelId: any;
  handleNivelChangeABP: any;
  selectedAsignatura: any;
  setSelectedAsignatura: any;
  handleAsignaturaChangeLocalABP: any;

  // shared
  promptData: any;
  setPromptData: React.Dispatch<React.SetStateAction<any>>;
  objetivosSeleccionados: any;
  setObjetivosSeleccionados: React.Dispatch<React.SetStateAction<any>>;
  setIsOAAdded: React.Dispatch<React.SetStateAction<boolean>>;
}>;

export default function ObjetivosSection({
  mode,

  // TP
  especialidadId,
  nivelTPId,
  asignaturaSeleccionadaTP,

  // ORG
  nivelOrg,
  asignaturaOrg,

  // CN
  nivelId,
  handleNivelChangeABP,
  selectedAsignatura,
  setSelectedAsignatura,
  handleAsignaturaChangeLocalABP,

  // shared
  promptData,
  setPromptData,
  objetivosSeleccionados,
  setObjetivosSeleccionados,
  setIsOAAdded,
}: Props) {
  const resetKeyTP = useMemo(
    () => `${especialidadId || ""}|${nivelTPId || ""}`,
    [especialidadId, nivelTPId]
  );

  const content = (() => {
    switch (mode) {
      case "TP":
        return (
          <TabsObjetivosTP
            resetKey={resetKeyTP}
            asignaturaSeleccionada={asignaturaSeleccionadaTP}
            nivelTPId={nivelTPId}
            promptData={promptData}
            setPromptData={setPromptData}
            setIsOAAdded={setIsOAAdded}
          />
        );

      case "ORG":
        return (
          <TabsObjetivosOrganizacion
            nombreNivel={nivelOrg.nombre}
            asignaturaSeleccionada={asignaturaOrg.id ? asignaturaOrg : null}
            setPromptData={setPromptData}
            objetivosSeleccionados={objetivosSeleccionados}
            setObjetivosSeleccionados={setObjetivosSeleccionados}
            setIsOAAdded={setIsOAAdded}
          />
        );

      case "CN":
      default:
        return (
          <CurriculumNacionalABPPanel
            nivelId={nivelId}
            handleNivelChangeABP={handleNivelChangeABP}
            selectedAsignatura={selectedAsignatura}
            setSelectedAsignatura={setSelectedAsignatura}
            handleAsignaturaChangeLocalABP={handleAsignaturaChangeLocalABP}
            promptData={promptData}
            setPromptData={setPromptData}
            objetivosSeleccionados={objetivosSeleccionados}
            setObjetivosSeleccionados={setObjetivosSeleccionados}
            setIsOAAdded={setIsOAAdded}
          />
        );
    }
  })();

  return (
    <Grid item xs={12} mt={1}>
      {content}
    </Grid>
  );
}
